import { render, staticRenderFns } from "./ProgressionHierarchy.vue?vue&type=template&id=8c6e2d48"
import script from "./ProgressionHierarchy.vue?vue&type=script&lang=js"
export * from "./ProgressionHierarchy.vue?vue&type=script&lang=js"
import style0 from "./ProgressionHierarchy.vue?vue&type=style&index=0&id=8c6e2d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports